import { Box, Shimmer } from '@betterment/samba-react';

export const TableSkeleton: React.FC<{ rowCount: number }> = ({ rowCount }) => {
  return (
    <>
      {Array.from({ length: rowCount }).map((_, index) => (
        <Box
          key={`shimmer-row-${index}`} // eslint-disable-line react/no-array-index-key
          css={{
            px: 'space.400',
            py: 'space.200',
            display: 'grid',
            gap: 'space.200',
            gridTemplateColumns: '1fr 1fr 2fr 1fr',
            alignItems: 'center',
          }}
        >
          {['1', '2', '3', '4'].map(area => (
            <Box key={area} css={{ gridArea: area }}>
              <Shimmer
                css={{
                  height: 'size.300',
                  borderRadius: 'radius.100',
                }}
              />
            </Box>
          ))}
        </Box>
      ))}
    </>
  );
};
